import React, { useEffect, useState } from "react";
import LinksComponent from "../../../components/Tenant/LinksComponent/LinksComponent";
import { Menu } from "@headlessui/react";
import DataTableComponent from "../../../components/Tenant/DataTableComponent/DataTableComponent";
import { toast } from "react-hot-toast";
import ImageModal from "../../../components/Tenant/ImageModal/ImageModal";
import { TbTransfer } from "react-icons/tb";
import { useFetchAllCommunityMutation, useFetchCommunityCategoryMutation, useFetchDetailedPostMutation, usePostCommunityMutation, useReviewCommunityPostMutation } from "../../../features/tenant/community/communityApi";
import view from "../../../assests/tenant/images/view.svg";
import PostReviewModal from "./PostModal";
import { CircleLoaderComponent } from "../../../components/Loader/CircleLoaderComponent";
import ModalComponent from "../../../components/Tenant/ModalComponent/ModalComponent";
import AddPostModal from "./AddPostModal";
import { HiOutlinePlus } from "react-icons/hi";
import { useUploadSingleFileMutation } from "../../../features/admin/imageUpload/imageUploadApi";

const DetailRow = ({ label, value }) => (
  <div className="flex justify-between py-1 text-sm border-b last:border-0">
    <span className="font-medium text-gray-600">{label}</span>
    <span className="text-gray-800">{value || "-"}</span>
  </div>
);

const CommunityList = () => {
  const primaryColor = JSON.parse(sessionStorage.getItem("vendorTheme")).theme
    .color_shades;
  const [limit, setLimit] = useState(10);
  const [offset, setOffset] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [paginationResetToggle, setPaginationResetToggle] = useState(false);
  const [levelList, setLevelList] = useState([]);
  const [selectedPost, setSelectedPost] = useState({});
  const [showPost, setShowPost] = useState(false);
  const [image, setImage] = useState("");
  const [showImage, setShowImage] = useState(false);
  const [allCommunityData, setAllCommunityData] = useState([])
  const [communityCount, setCommunityCount] = useState(0)
  const [communityCategory, setCommunityCategory] = useState([])
  const [likeModal, setLikeModal] = useState(false);
  const [postModal,setPostModal] = useState(false);
  const [commentModal, setCommentModal] = useState(false);
  const [modalType, setModalType] = useState("");
  const [showImageModal, setShowImageModal] = useState(false);
  const initialRequest = {
    mobile: "",
    status: "",
    category_id: "",
  };
  const [request, setRequest] = useState(initialRequest);

  const [
    fetchAllCommunity,
    {
      data: fetchAllCommunityData,
      isLoading: fetchAllCommunityIsLoading,
      isError: fetchAllCommunityIsError,
      error: fetchAllCommunityError,
    },
  ] = useFetchAllCommunityMutation()

  const [
    fetchCommunityCategory,
    {
      data: fetchCommunityCategoryData,
      isLoading: fetchCommunityCategoryIsLoading,
      isError: fetchCommunityCategoryIsError,
      error: fetchCommunityCategoryError,
    },
  ] = useFetchCommunityCategoryMutation()


  const [
    reviewCommunityPost,
    {
      data: reviewCommunityPostData,
      isLoading: reviewCommunityPostIsLoading,
      isError: reviewCommunityPostIsError,
      error: reviewCommunityPostError,
    },
  ] = useReviewCommunityPostMutation()

  const [
    fetchDetailedPost,
    {
      data: fetchDetailedPostData,
      isLoading: fetchDetailedPostIsLoading,
      isError: fetchDetailedPostIsError,
      error: fetchDetailedPostError,
    },
  ] = useFetchDetailedPostMutation()

  const [
    postCommunity,
    {
      data: postCommunityData,
      isLoading: postCommunityIsLoading,
      isError: postCommunityIsError,
      error: postCommunityError,
    },
  ] = usePostCommunityMutation()


  const getAllCommunity = (req = request) => {
    fetchAllCommunity({
      token: sessionStorage.getItem("access_token"),
      tenant_id: JSON.parse(sessionStorage.getItem("vendorData")).tenant_id,
      body: {
        limit: limit,
        offset: offset,
        ...req
      }
    });
  }


  useEffect(() => {
    getAllCommunity()
  }, [limit, offset]);

  if (fetchAllCommunityIsLoading) {
    toast.loading("Loading Employee List ...", {
      id: "fetchAllCata",
    });
  }
  if (fetchAllCommunityData) {
    toast.dismiss();
  }

  const handleMediaImage = (row) => {
    setShowImage(!showImage);
    setImage(row.media.length > 0 ? row.media[0] : "");
  };

  const reviewPost = (id, status, remark = "") => {
    if (!id || !status) return

    reviewCommunityPost({
      token: sessionStorage.getItem("access_token"),
      tenant_id: JSON.parse(sessionStorage.getItem("vendorData")).tenant_id,
      body: {
        status: status,
        id: id,
        remark: remark
      }
    })
  }
  const columns = [
    {
      name: "SNo",
      cell: (row, idx) => offset + idx + 1,
      width: "70px",
    },
    {
      name: "Posted By",
      cell: (row) => (
        <div>
          <div className="font-medium text-gray-800">{row.name || "-"}</div>
          <div className="text-xs text-gray-500">{row.mobile || "-"}</div>
        </div>
      ),
      minWidth: "160px",
    },
    {
      name: "Category",
      cell: (row) =>
        row.category_name ? (
          <span className="inline-block bg-indigo-100 text-indigo-800 text-xs px-2 py-1 rounded">
            {row.category_name}
          </span>
        ) : (
          "-"
        ),
      width: "130px",
    },
    {
      name: "Title",
      cell: (row) => (
        <div className="text-sm text-gray-700 line-clamp-1 max-w-xs">
          {row.title || "-"}
        </div>
      ),
      grow: 1,
    },
    {
      name: "Likes",
      cell: (row) => (
        <span className="text-sm font-medium" onClick={() => { 
          setModalType("like");
          openLikeModal(row) }}>{row.like_count ?? 0}</span>
      ),
      width: "90px",
    },
    {
      name: "Comments",
      cell: (row) => (
        <span className="text-sm font-medium" onClick={() => { 
          setModalType("comment");
          openLikeModal(row) }}>{row.comment_count ?? 0}</span>
      ),
      width: "110px",
    },
    {
      name: "Media",
      cell: (row) =>
        row.media?.length > 0 ? (
          <button type="button" className="bg-black p-1 rounded-sm">
            <img src={view} alt="" onClick={() => handleMediaImage(row)} />
          </button>
        ) : (
          <span className="text-gray-400 text-xs">-</span>
        ),
      width: "130px",
    },
    {
      name: "Remark",
      cell: (row) => <span className="text-sm font-medium">{row.remark || ""}</span>,
    },
    {
      name: "Status",
      cell: (row) =>
        row.status === "1" ? (
          <span className="inline-block bg-green-100 text-green-800 text-xs px-2 py-1 rounded">
            Approved
          </span>
        ) : row.status === "2" ? (
          <span className="inline-block bg-red-100 text-red-800 text-xs px-2 py-1 rounded">
            Rejected
          </span>
        ) : (
          <span className="inline-block bg-yellow-100 text-yellow-800 text-xs px-2 py-1 rounded">
            Pending
          </span>
        ),
      width: "120px",
    },
    {
      name: "Action",
      cell: (row) =>
        row.status === "0" ? (
          <button
            onClick={() => openReviewModal(row)}
            className="rounded bg-blue-600 px-4 py-1.5 text-xs font-medium text-white hover:bg-blue-700"
          >
            Review Post
          </button>
        ) : (
          <span className="text-gray-400 text-xs">-</span>
        ),
      minWidth: "160px",
    }
  ];

  const openReviewModal = (row) => {
    setSelectedPost(row)
    setShowPost(true)
  }

  const openLikeModal = (row) => {
    fetchDetailedPost({
      token: sessionStorage.getItem("access_token"),
      tenant_id: JSON.parse(sessionStorage.getItem("vendorData")).tenant_id,
      post_id: row.id,
    })
  }

  const handlePageChange = (pageNumber) => {
    const newOffset = (pageNumber - 1) * limit;
    setOffset(newOffset);
    setCurrentPage(pageNumber);
  };

  const handlePerRowsChange = (newPerPage, page) => {
    setLimit(newPerPage);
  };

  useEffect(() => {
    fetchCommunityCategory({
      token: sessionStorage.getItem("access_token"),
      tenant_id: JSON.parse(sessionStorage.getItem("vendorData")).tenant_id,
    })
  }, [])

  useEffect(() => {
    if (fetchAllCommunityData && fetchAllCommunityData?.body?.data) {
      console.log("community data", fetchAllCommunityData.body);
      setAllCommunityData(fetchAllCommunityData.body.data);
      setCommunityCount(fetchAllCommunityData.body.count || 0);
    }
  }, [fetchAllCommunityData])

  useEffect(() => {
    if (reviewCommunityPostData && reviewCommunityPostData) {
      toast.success("Post Reviewed Successfully");
      getAllCommunity();
      setShowPost(false);
      setSelectedPost({});
      setPostModal(false);
    }
    if (reviewCommunityPostError) {
      toast.error("Error in Reviewing Post");
    }
  }, [reviewCommunityPostData, reviewCommunityPostError])

  useEffect(() => {
    if (postCommunityData && postCommunityData.body) {
      toast.success("Post Uploaded Successfully");
      reviewCommunityPost({
        token: sessionStorage.getItem("access_token"),
        tenant_id: JSON.parse(sessionStorage.getItem("vendorData")).tenant_id,
        body: {
          status: 1,
          id: postCommunityData.body.id,
          remark: "Posted by admin"
        }
      })
    }
    if (postCommunityError) {
      toast.error("Error in Uploading Post");
    }
  }, [postCommunityData, postCommunityError])

  useEffect(() => {
    console.log("fetchCommunityCategoryData", fetchCommunityCategoryData, fetchAllCommunityError)
    if (fetchCommunityCategoryData && fetchCommunityCategoryData?.body?.category) {
      setCommunityCategory(fetchCommunityCategoryData?.body?.category);
    }
  }, [fetchCommunityCategoryData])

  useEffect(() => {
    console.log(fetchDetailedPostData, "fetchDetailedPostData")
    if (fetchDetailedPostData && fetchDetailedPostData?.body) {
      setSelectedPost(fetchDetailedPostData?.body);
      if (modalType === "comment") {
        setCommentModal(true);
      } else 
      {
        setLikeModal(true);
      }
    }
  }, [fetchDetailedPostData])

  const clearFilters = () => {
    setRequest(initialRequest)
    getAllCommunity(initialRequest)
    // fetchAppUserByUserTypeFunction(initialRequest)
  }

  const handlePostUpload = (data) => {
    postCommunity({
      token: sessionStorage.getItem("access_token"),
      tenant_id: JSON.parse(sessionStorage.getItem("vendorData")).tenant_id,
      body: {
        category_id: data.category,
        title: data.title,
        content_text: data.content,
        media: [data.media]
      }
    })
  }


  return (
    <>
      {" "}
      <div className="flex w-full bg-gray-200 h-full justify-center">
        <div className="w-full ">
          <div className="border-b bg-white border-gray-300 pl-6 py-2 shadow-sm text-xl font-bold">
            Community List
            <LinksComponent />
          </div>

          {
            (fetchDetailedPostIsLoading || postCommunityIsLoading || reviewCommunityPostIsLoading) ? (
              <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-white/60 backdrop-blur-sm">
                <CircleLoaderComponent />
              </div>
            ) : null
          }

          <div className="p-3">
            <div className="p-3 w-full bg-white shadow rounded-lg">
              <div className="border-b  border-gray-300 bg-gray-50 rounded-t-lg p-3">
                <div className="flex  space-x-2 space-between">
                  <div className="w-52 h-10 ">
                    <div className="relative searchin">
                      <label class="block text-sm font-medium capitalize leading-6 text-gray-900 mb-1">
                        Mobile
                      </label>
                      <input
                        type="search"
                        id="default-search"
                        className="w-full px-2 text-sm text-gray-900 border border-gray-300 rounded-lg bg-white focus:ring-blue-500 focus:border-blue-500 inputp"
                        placeholder="Mobile..."
                        required
                        value={request.mobile}
                        onChange={(e) => {
                          const newValue = e.target.value;
                          setRequest((prevState) => {
                            return { ...prevState, mobile: newValue };
                          });
                        }}
                      />
                    </div>
                  </div>

                  <div className="w-52 h-10">
                    <div className="relative searchin">
                      <label class="block text-sm font-medium capitalize leading-6 text-gray-900 mb-1">
                        User Status
                      </label>
                      <select
                        className="w-full px-2 text-sm text-gray-900 border border-gray-300 rounded-lg bg-white focus:ring-blue-500 focus:border-blue-500 inputp"
                        name="User Scanned"
                        value={request.status}
                        onChange={(e) => {
                          const newValue = e.target.value;
                          setRequest((prevState) => {
                            return { ...prevState, status: newValue };
                          });
                        }}
                        id=""
                      >
                        <option selected value={""}>
                          All
                        </option>
                        <option value={"0"}>
                          Pending
                        </option>
                        <option value={"1"}> Approved</option>
                        <option value={"2"}> Rejected</option>
                      </select>
                    </div>
                  </div>

                  <div className="w-52 h-10">
                    <div className="relative searchin">
                      <label class="block text-sm font-medium capitalize leading-6 text-gray-900 mb-1">
                        Category
                      </label>
                      <select
                        className="w-full px-2 text-sm text-gray-900 border border-gray-300 rounded-lg bg-white focus:ring-blue-500 focus:border-blue-500 inputp"
                        name="User Scanned"
                        value={request.category_id}
                        onChange={(e) => {
                          const newValue = e.target.value;
                          setRequest((prevState) => {
                            return { ...prevState, category_id: newValue };
                          });
                        }}

                        id=""
                      >
                        <option selected value={""}>
                          All
                        </option>
                        {
                          communityCategory && communityCategory.length > 0 && communityCategory.map((category) =>
                            <option value={category.id}>
                              {category.name
                                ? category.name.charAt(0).toUpperCase() + category.name.slice(1)
                                : ""}
                            </option>
                          )
                        }
                      </select>
                    </div>
                  </div>


                  <div className="flex flex-row  gap-2 h-10">
                    <div className="relative searchin">
                      <label class="block text-sm font-medium capitalize leading-6 text-gray-900 mb-1">
                        &nbsp;
                      </label>
                      <button
                        className="btn btn-outline-primary clear-both float-right  p-2"
                        onClick={() => {
                          getAllCommunity(request);
                          // fetchAppUserByUserTypeFunction();
                          // fetchAppUserByUserTypeCsvFunction();
                        }}
                      >
                        Search
                      </button>
                    </div>
                    <div className="relative searchin">
                      <label class="block text-sm font-medium capitalize leading-6 text-gray-900 mb-1">
                        &nbsp;
                      </label>
                      <button
                        className="btn btn-outline-primary clear-both float-right p-2"
                        onClick={() => {
                          clearFilters();
                        }}
                      >
                        Clear Filter
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <DataTableComponent
                keyField={(row) => row.SNo}
                columns={columns}
                data={
                  allCommunityData
                }
                totalRows={
                  communityCount
                }
                handlePerRowsChange={handlePerRowsChange}
                handlePageChange={handlePageChange}
                paginationDefaultPage={currentPage}
                paginationResetDefaultPage={paginationResetToggle}
              >
                <div className="flex m-2 space-x-2 justify-end"></div>
              </DataTableComponent>

              <div
                className="fixed bottom-0 right-10 w-16 h-16 mr-10 mb-6 cursor-pointer"
                id="box_btn"
              >
                <div className="text-right">
                  <Menu className="relative inline-block text-left">
                    <div>
                      <Menu.Button
                        onClick={() => setPostModal(true)}
                        className="inline-flex justify-cente w-12 h-12 rounded-full text-sm font-medium text-white hover:bg-opacity-80 focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-opacity-75 "
                        style={{ backgroundColor: `${primaryColor["700"]}` }}
                      >
                        <HiOutlinePlus className="w-full h-full p-3" />
                      </Menu.Button>
                    </div>
                  </Menu>
                </div>

              </div>

              {showImageModal && (
                <ImageModal
                  show={showImageModal ? true : false}
                  setShow={setShowImageModal}
                  size="md"
                  data={showImageModal}
                >
                  <div className="aspect-h-1 aspect-w-1 w-full overflow-hidden rounded-lg bg-gray-200 xl:aspect-h-8 xl:aspect-w-7">
                    <img
                      src={showImageModal}
                      className=" w-full object-cover object-center group-hover:opacity-75 h-40 max-w-full max-h-full"
                    />
                  </div>
                </ImageModal>
              )}

              {showImage && (
                <ImageModal
                  show={showImage}
                  setShow={setShowImage}
                  size="md"
                  data={image}
                >
                  <div className="w-[400px] h-[400px] overflow-hidden rounded-lg bg-gray-200">
                    <img
                      src={image}
                      alt="product-image"
                      className="w-full h-full object-contain"
                    />
                  </div>
                </ImageModal>
              )}

              {
                likeModal && (
                  <ModalComponent
                    show={likeModal}
                    size="sm"
                    setShow={() => {
                      setLikeModal(false);
                      setModalType("")
                      setSelectedPost({});
                    }}
                  >
                    <div className="p-4">
                      <h2 className="mb-3 text-base font-semibold text-gray-800">
                        Likes ({selectedPost?.likes?.length || 0})
                      </h2>

                      {(!selectedPost?.likes || selectedPost.likes.length === 0) ? (
                        <p className="text-sm text-gray-500 text-center py-6">
                          No likes yet
                        </p>
                      ) : (
                        <div className="max-h-72 overflow-y-auto space-y-2">
                          {selectedPost.likes.map((like, index) => {
                            const initial = like?.name
                              ? like.name.charAt(0).toUpperCase()
                              : "?";

                            const likedAt = like?.created_at
                              ? new Date(like.created_at).toLocaleString()
                              : null;

                            return (
                              <div
                                key={index}
                                className="flex items-center gap-3 rounded-xl border bg-white p-3 shadow-sm hover:bg-gray-50 transition"
                              >
                                {/* Avatar */}
                                <div
                                  className="flex-shrink-0 h-10 w-10 rounded-full overflow-hidden
                               flex items-center justify-center
                               bg-gradient-to-br from-indigo-500 to-purple-500
                               text-sm font-semibold text-white"
                                >
                                  {initial}
                                </div>

                                {/* Info */}
                                <div className="flex flex-col justify-center">
                                  <span className="text-sm font-medium text-gray-800">
                                    {like.name || "-"}
                                  </span>
                                  <span className="text-xs text-gray-500">
                                    {like.mobile || "-"}
                                  </span>

                                  {likedAt && (
                                    <span className="mt-1 text-[11px] text-gray-400">
                                      Liked on {likedAt}
                                    </span>
                                  )}
                                </div>
                              </div>
                            );
                          })}
                        </div>
                      )}
                    </div>
                  </ModalComponent>
                )
              }

              {
                commentModal && (
                  <ModalComponent
                    show={commentModal}
                    size="md"
                    setShow={() => {
                      setCommentModal(false);
                      setSelectedPost({});
                      setModalType("")
                    }}
                  >
                    <div className="p-4">
                      <h2 className="mb-3 text-base font-semibold text-gray-800">
                        Comments ({selectedPost?.comments?.length || 0})
                      </h2>

                      {(!selectedPost?.comments || selectedPost.comments.length === 0) ? (
                        <p className="text-sm text-gray-500 text-center py-6">
                          No comments yet
                        </p>
                      ) : (
                        <div className="max-h-80 overflow-y-auto space-y-3">
                          {selectedPost.comments.map((comment, index) => {
                            const initial = comment?.name
                              ? comment.name.charAt(0).toUpperCase()
                              : "?";

                            const commentedAt = comment?.created_at
                              ? new Date(comment.created_at).toLocaleString()
                              : null;

                            return (
                              <div
                                key={index}
                                className="flex gap-3 rounded-xl border bg-white p-3 shadow-sm hover:bg-gray-50 transition"
                              >
                                {/* Avatar */}
                                <div
                                  className="flex-shrink-0 h-10 w-10 rounded-full overflow-hidden
                    flex items-center justify-center
                    bg-gradient-to-br from-emerald-500 to-teal-500
                    text-sm font-semibold text-white"
                                >
                                  {initial}
                                </div>

                                {/* Comment Content */}
                                <div className="flex-1">
                                  <div className="flex items-center justify-between">
                                    <span className="text-sm font-medium text-gray-800">
                                      {comment.name} ({comment.mobile})
                                    </span>
                                    {commentedAt && (
                                      <span className="text-[11px] text-gray-400">
                                        {commentedAt}
                                      </span>
                                    )}
                                  </div>

                                  <p className="mt-1 text-sm text-gray-700 break-words">
                                    {comment.comment_text || "-"}
                                  </p>
                                </div>
                              </div>
                            );
                          })}
                        </div>
                      )}
                    </div>
                  </ModalComponent>
                )
              }

              <AddPostModal
                isOpen={postModal}
                onClose={() => setPostModal(false)}
                categories={communityCategory}
                onSubmit={handlePostUpload}
              />


              <PostReviewModal
                isOpen={showPost}
                post={selectedPost}
                onClose={() => {
                  setShowPost(false)
                  setSelectedPost({})
                }}
                reviewPost={reviewPost}
              />

            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CommunityList;
